import type {
  FullPublicOrderFragment,
  FullPublicOrderItemFragment,
  FullPublicProfileFragment,
  FullPublicProfileProductFragment,
} from 'apollo-gql'

import {
  trackCheckoutStep1,
  trackCheckoutStep2,
  trackCheckoutStep3,
  trackCheckoutStep4,
  trackCheckoutStep5,
  trackCheckoutStep6,
} from '../checkout'
import { CheckoutStepName, CheckoutStepNameValueType } from './sdk'
import getMarketTrackingProperties from './utils/getMarketTrackingProperties'

type StepNames = {
  [index: number]: CheckoutStepNameValueType
}

const STEP_NAMES: StepNames = {
  1: CheckoutStepName.REQUEST_FORM,
  2: CheckoutStepName.FILLED_IN_REQUEST_FORM,
  3: CheckoutStepName.CHECKOUT_PAGE,
  4: CheckoutStepName.CHECKOUT_FORM,
  5: CheckoutStepName.PAYMENT,
  6: CheckoutStepName.PAYMENT_INFO_SUBMITTED,
  7: CheckoutStepName.ORDER_SUBMITTED,
}

interface TrackCheckoutStepParamaters {
  checkoutStepId: number
  profile?: FullPublicProfileFragment
  profileProduct?: FullPublicProfileProductFragment
  productSlug?: string | string[]
  orderItems?: FullPublicOrderItemFragment[]
  order?: FullPublicOrderFragment
  paymentMethod?: string
  actionFields?: {
    didUseStoredPaymentMethod?: boolean
    didCheckStorePaymentMethod?: boolean
  }
}

const trackCheckoutStep = async (
  paramaters: TrackCheckoutStepParamaters,
): Promise<void> => {
  const {
    checkoutStepId,
    profile,
    productSlug,
    profileProduct,
    orderItems,
    order,
    paymentMethod,
    actionFields,
  } = paramaters

  const { checkoutStepStarted } = await import('./sdk')
  checkoutStepStarted({
    ...getMarketTrackingProperties(),
    checkoutStepId,
    checkoutStepName: STEP_NAMES[checkoutStepId],
    orderId: order?.id,
    orderTotalPriceIncVatUsd: order?.totalPriceIncVat.valueInCent,
    orderItemCount: order?.items.length,
    paymentMethod,
    couponCode: order?.couponCode,
    couponId: order?.couponId,
    productTypes: null,
  })

  switch (checkoutStepId) {
    case 1:
      trackCheckoutStep1(profile.slug, productSlug, profileProduct)
      break

    case 2:
      trackCheckoutStep2()
      break

    case 3:
      trackCheckoutStep3(orderItems)
      break

    case 4:
      trackCheckoutStep4()
      break

    case 5:
      trackCheckoutStep5()
      break

    case 6:
      trackCheckoutStep6(paymentMethod, actionFields)
      break

    default:
      break
  }
}

export default trackCheckoutStep
